import './App.css';
import React from 'react';
import {Route, Routes} from "react-router-dom";
import HomePage from './Pages/home';
import LoginPage from './Pages/login';
import ImpressumPage from "./Pages/contact_impressum";
import './index.css'
import SocietyPage from "./Pages/verein/society";
import 'bootstrap/dist/css/bootstrap.min.css';
import RegisterPage from "./Pages/registerpage";
import CalendarPage from "./Pages/calendarPage";
import GalleryPageMeer from "./Pages/Gallary/galleryMeer";
import GalleryPageSeen from "./Pages/Gallary/gallery";
import AdminPage from "./Pages/admin/adminHome"
import ProtectedRoute from "./protectedroute";
import RequireAuth from "./requireAuth";
import MembersPage from "./Pages/member/membersPage";
import AssosiationPage from "./Pages/verein/association"
import MemberPage from "./Pages/verein/memberpage"
import OrdersPage from "./Pages/verein/orders";
import EducationPage from "./Pages/education/educationPage"
import DivePage from "./Pages/education/snorkDive";
import PoolPage from "./Pages/education/pooltraining";
import MedPage from "./Pages/education/med";
import JugendPage from "./Pages/youth/jugendPage";
import Youthtraining from "./Pages/youth/youthtraining";
import EnvironmentPage from "./Pages/youth/environment";
import ContactPage from "./Pages/contact";
import BlogPage from "./Pages/verein/Blog";
import AlbumList from "./Components/gallery/albumlist";
import AlbumDetail from "./Components/gallery/albumdetails";
import ImageManager from "./Components/admin/imagemanager";
import AlbumManager from "./Components/admin/albummanager";
import EventDetail from "./Components/Events/EventDetail";
import BlogDetail from "./Components/Blog/BlogDetail";

function App() {
    return (<>
        <Routes>
            <Route path='/' exact element={<HomePage/>}/>
            <Route path='/login' exact element={<LoginPage/>}/>
            <Route path='/tsc-blog' exact element={<BlogPage/>}/>
            <Route path='/tsc-blog/:id' element={<BlogDetail />} />
            <Route path='/galerie/meer' element={<GalleryPageMeer/>}/>
            <Route path='/galerie' element={<GalleryPageSeen/>}/>
            <Route path='/kontakt' element={<ContactPage/>}/>
            <Route path='/impressum' element={<ImpressumPage/>}/>
            <Route path='/verein' element={<SocietyPage/>}/>
            <Route path='/login/register' element={<RegisterPage/>}/>
            <Route path='/kalender' element={<CalendarPage/>}/>
            <Route path='/verbaende' element={<AssosiationPage/>}/>
            <Route path='/mitglied-werden' element={<MemberPage/>}/>
            <Route path='/satzung-ordnung' element={<OrdersPage/>}/>
            <Route path='/ausbildung' element={<EducationPage/>}/>
            <Route path='/schnorcheln-tauchen' element={<DivePage/>}/>
            <Route path='/schwimmhallentraining' element={<PoolPage/>}/>
            <Route path='/medizin' element={<MedPage/>}/>
            <Route path='/kinder-jugend/training' element={<Youthtraining/>}/>
            <Route path='/kinder-jugend' element={<JugendPage/>}/>
            <Route path='/umwelt' element={<EnvironmentPage/>}/>
            <Route path="/alben" element={<AlbumList />} />
            <Route path="/album/:id" element={<AlbumDetail />} />
            <Route path="/admin/albums/:id/images" element={<ImageManager />} />
            <Route path="/admin/gallery" element={<AlbumManager />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route
                path="/mitglieder"
                element={
                    <RequireAuth>
                        <MembersPage />
                    </RequireAuth>
                }
            />
            <Route
                path="/admin/home/*"
                element={
                    <ProtectedRoute>
                        <AdminPage/>
                    </ProtectedRoute>
                }
            />
        </Routes>
    </>);
}

export default App;

